import * as React from 'react';
import { useEffect, useMemo, useState } from 'react';
import { motion, useAnimation } from 'framer-motion';

type CatProps = {
  isAnimate: boolean
  className?: string
};

export const Cat: React.FC<CatProps> = ({
  isAnimate,
  className,
}) => {
  const [isAnimated, setIsAnimated] = useState(false);

  const controlsSvg = useAnimation();
  const controlsHead = useAnimation();
  const controlsHands = useAnimation();
  const controlsHighFive = useAnimation();

  const hideAnimation = useMemo(() => (!isAnimate && isAnimated), [isAnimate, isAnimated]);

  useEffect(() => {
    if (isAnimate) {
      controlsSvg.start({
        x: 0,
        transition: {
          ease: [0.6, 0.01, -0.05, 0.95],
          duration: .5,
          delay: .5,
        },
      });
      controlsHead.start({
        x: 0,
        transition: {
          ease: [0.6, 0.01, -0.05, 0.95],
          duration: 1,
          delay: 1,
        },
      });
      controlsHands.start({
        x: [100, -20, 0],
        transition: {
          ease: [0.6, 0.01, -0.05, 0.95],
          duration: 1,
          delay: 0,
        },
      });
      controlsHighFive.start({
        scale: 1,
        x: -20,
        transition: {
          ease: [0.6, 0.01, -0.05, 0.95],
          duration: 1,
          delay: 1.3,
        },
      });
    }
    if (hideAnimation) {
      controlsSvg.start({
        x: -8,
        transition: {
          ease: [0.6, 0.01, -0.05, 0.95],
          duration: .5,
          delay: .8,
        },
      });
      controlsHead.start({
        x: 200,
        transition: {
          ease: [0.6, 0.01, -0.05, 0.95],
          duration: 1,
          delay: .3,
        },
      });
      controlsHands.start({
        x: [0, -20, 100],
        transition: {
          ease: [0.6, 0.01, -0.05, 0.95],
          duration: 1,
          delay: .8,
        },
      });
      controlsHighFive.start({
        scale: .6,
        x: 180,
        transition: {
          ease: [0.6, 0.01, -0.05, 0.95],
          duration: 1,
          delay: 0,
        },
      });
    }
  }, [
    isAnimate,
    hideAnimation,
    controlsSvg,
    controlsHead,
    controlsHands,
    controlsHighFive,
  ]);

  return (
    <motion.svg
      className={className}
      width="167"
      height="282"
      viewBox="0 0 167 282"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"

      initial={{ x: -8 }}
      animate={controlsSvg}
    >
      <g 
        clipPath="url(#clip0_244:3260)"
      >
        <motion.g
          initial={{ x: 200 }}
          animate={controlsHead}
        >
          <path
            d="M51.6961 90.1081C54.6494 99.5536 64.1001 112.394 74.0922 120.658C76.7501 122.872 79.0144 124.987 79.162 125.381C79.3097 125.775 79.4574 135.564 79.4574 147.076C79.4574 166.361 79.3589 168.23 78.5221 170.05C78.0299 171.182 75.1258 174.576 71.8772 177.872C60.0639 189.728 51.893 202.962 51.7453 210.39C51.5977 215.851 52.9759 217.081 60.6053 218.311C67.5948 219.393 90.1386 219.786 100.524 218.999L108.892 218.409L114.75 219.934C120.804 221.508 128.876 222.443 132.519 222.049C135.521 221.754 135.817 222.246 134.586 225.887C133.306 229.625 132.716 235.234 133.552 235.234C133.848 235.234 134.192 234.938 134.291 234.594C134.389 234.299 134.734 232.872 135.029 231.544C135.915 227.756 138.081 222.246 138.918 221.557C139.361 221.262 140.099 220.967 140.64 220.967C141.526 220.967 141.526 221.262 141.231 225.542C140.788 231.495 142.117 240.645 143.298 239.514C143.446 239.366 143.495 236.119 143.495 232.331C143.446 228.543 143.545 224.312 143.741 222.935C144.037 220.672 144.283 220.328 145.661 219.639C146.547 219.196 147.581 218.999 147.975 219.147C148.368 219.245 148.91 220.672 149.205 222.295C149.5 223.87 150.091 226.034 150.534 227.116C151.765 229.97 152.355 228.691 151.617 224.903C151.223 223.132 150.78 220.918 150.633 219.885L150.288 218.114L154.324 215.949C156.539 214.818 158.656 213.342 159.049 212.751C159.689 211.768 159.739 203.798 159.443 148.109L159.05 84.5491L157.327 82.6305C155.653 80.7611 149.402 77.3174 147.679 77.3174C146.596 77.3174 146.646 75.8908 147.876 71.66C148.418 69.7906 148.861 67.872 148.861 67.4784C148.811 66.1993 146.104 69.8398 145.415 72.0535C144.135 76.4319 144.086 76.4811 142.068 76.0875C141.083 75.8908 140.05 75.6448 139.804 75.4972C139.361 75.202 139.705 65.6582 140.345 60.8371C140.591 58.6233 140.591 58.4265 139.853 59.0168C138.475 60.1975 137.49 64.1331 137.195 69.5938C137.047 72.4963 136.703 75.0053 136.506 75.1528C136.309 75.2512 135.571 75.2512 134.881 75.0544C133.356 74.7101 132.765 72.2995 132.42 64.8219C132.273 61.9194 132.076 59.3612 131.879 59.2136C130.796 58.1313 130.058 64.4283 130.698 69.3478C130.993 71.5616 131.141 73.677 130.993 74.0213C130.845 74.3657 129.565 74.6609 127.646 74.7593C123.659 74.9561 114.947 76.1859 111.55 77.0714C109.286 77.6618 108.105 77.6618 102.69 76.9731C98.3587 76.4811 92.009 76.1859 82.1646 76.1859C69.4161 76.1367 67.398 76.2351 63.1156 77.1698C52.1391 79.5804 49.3827 82.6797 51.6961 90.1081ZM100.574 177.429C103.133 171.87 109.483 166.213 116.423 163.31C123.167 160.506 128.827 161.638 134.488 167.049C139.311 171.674 141.526 177.134 141.822 185.547C142.117 191.844 141.33 196.025 139.262 199.616C134.242 208.226 122.084 211.964 113.076 207.635C108.302 205.323 102.838 198.928 100.623 193.073C98.3586 187.022 98.3586 182.251 100.574 177.429ZM100.869 105.9C103.872 93.1582 115.734 86.0741 128.433 89.3702C135.029 91.092 139.853 95.2736 141.969 101.226C143.052 104.227 143.2 105.359 143.151 111.016C143.151 116.575 142.954 117.854 141.871 121.003C139.607 127.398 135.817 132.022 130.796 134.58C127.498 136.253 125.578 136.499 121.542 135.86C112.781 134.482 104.561 128.087 101.312 120.216C99.9338 116.821 99.7369 110.77 100.869 105.9ZM136.998 145.305C137.195 144.764 138.573 145.453 139.705 146.633C141.477 148.454 141.477 150.126 139.804 152.34C138.376 154.209 137.244 154.554 136.85 153.176C136.703 152.537 136.801 146.043 136.998 145.305Z"
            fill="#1F1F1F"
          />
          <path
            d="M114.202 186.148C115.758 187.208 116.196 187.256 121.934 187.111C126.944 186.967 128.16 186.774 128.889 186.052C129.667 185.281 129.667 185.185 128.889 184.366C128.16 183.692 126.944 183.499 121.254 183.403C114.98 183.258 112.499 183.595 112.499 184.655C112.499 184.848 113.278 185.522 114.202 186.148Z"
            fill="#1F1F1F"
          />
          <path
            d="M114.711 113.779C115.811 114.894 116.361 114.944 122.657 114.944C128.654 114.944 129.503 114.843 130.553 113.931L131.752 112.918L130.553 111.904C129.503 110.992 128.654 110.891 122.407 110.891C116.061 110.891 113.512 111.296 113.512 112.31C113.512 112.512 114.062 113.171 114.711 113.779Z"
            fill="#1F1F1F"
          />
        </motion.g>
      </g>
      <motion.path
        d="M145.477 258.785C146.264 265.77 148.626 271.722 152.709 276.69C155.709 280.379 158.169 281.756 160.235 280.92C161.957 280.182 162.892 278.313 163.679 273.788C163.974 271.869 164.761 269.312 165.45 268.082C167.172 264.737 167.122 259.425 165.351 255.49C164.22 253.079 163.974 251.653 163.728 246.488C163.384 239.897 163.088 238.962 160.678 236.896C159.35 235.814 158.809 235.667 157.333 235.913C147.986 237.634 144.001 245.357 145.477 258.785Z"
        fill="#1F1F1F"

        initial={{ x: 100 }}
        animate={controlsHands}
      />
      <g 
        clipPath="url(#clip1_244:3260)"
      >
        <motion.path
          d="M47.8885 41.6288C48.4458 43.3261 49.9405 45.3021 51.4098 46.3154C53.5631 47.7594 55.5898 48.3421 58.6804 48.3421L61.3404 48.3421L60.5804 49.8621C59.9471 51.1287 59.8204 51.6607 59.8204 53.282C59.8204 56.854 61.4924 59.7673 64.4057 61.1859C65.9003 61.9206 66.2803 62.0219 68.2563 61.9966C70.9163 61.9713 73.2216 61.2619 76.4136 59.4886C80.3909 57.2846 81.8602 56.626 84.6468 55.866C89.8654 54.422 89.3587 54.422 104.153 55.4607C117.149 56.3473 165.433 59.8527 177.087 61.2967C178.201 61.4487 179.291 61.55 179.544 61.55C179.975 61.55 180 60.4353 180 38.8769L180 16.2038L179.417 16.1025C179.113 16.0265 176.403 15.8491 152.413 14.8011C149.423 14.6491 145.471 14.4211 143.673 14.2944C140.025 14.0157 128.498 13.2558 119.1 12.6478C110.385 12.0904 98.504 11.5078 96.224 11.5078C93.7414 11.5078 91.8161 11.0264 89.0801 9.68379C86.4961 8.44247 85.6855 7.83448 82.3162 4.61717C78.5162 0.994545 75.4509 -0.348108 71.6763 -0.069444C69.4216 0.107887 67.927 0.741214 66.3057 2.2612C64.1777 4.23718 63.3417 6.69449 63.7724 9.55712C63.9244 10.5198 64.0004 11.3304 63.9497 11.3811C63.899 11.4318 62.9617 11.3558 61.847 11.2038C58.4524 10.7478 54.7538 11.6091 52.2965 13.4077C50.7512 14.5477 49.4845 17.005 49.3578 19.209C49.2312 20.9823 49.9405 23.389 51.0045 25.0356C51.8658 26.3783 53.8165 28.4556 54.7031 28.9876L55.3871 29.4183L53.6898 30.2543C51.5618 31.2929 49.4085 33.4209 48.4458 35.3715C47.5845 37.1195 47.3312 39.9315 47.8885 41.6288ZM50.3205 37.2968C50.7258 35.8782 52.5751 34.0035 54.3485 33.1929C56.6031 32.1796 58.6044 31.9009 60.7831 32.2556C65.2923 32.9902 68.1296 35.5995 68.1296 38.9688C68.1296 44.7448 58.6804 47.8101 52.9298 43.8834C50.5232 42.2368 49.5858 39.9315 50.3205 37.2968ZM52.6005 17.3597C53.9685 14.6744 57.8444 13.2811 61.5937 14.1677C66.3057 15.2571 69.675 18.6264 69.675 22.2743C69.675 24.7316 68.3323 26.5303 65.799 27.4929C63.899 28.2023 60.2764 28.0756 58.1231 27.2143C53.5631 25.4156 50.9032 20.653 52.6005 17.3597ZM63.1897 50.6727C65.4697 46.4421 72.2083 44.6434 75.7042 47.3034C77.3509 48.5954 77.7815 49.3047 77.8829 51.154C77.9842 52.4714 77.8829 53.0034 77.4015 53.9913C75.7296 57.462 71.0683 59.6913 67.243 58.906C62.911 58.0193 61.163 54.4473 63.1897 50.6727ZM67.6483 5.1745C70.435 0.943878 78.6429 2.94519 81.1762 8.4678C82.1135 10.4944 82.0628 12.6984 81.0495 14.1171C79.8842 15.7891 78.4655 16.4477 76.0336 16.4477C74.2856 16.4477 73.7789 16.3464 72.3349 15.6624C68.6616 13.9144 66.6857 11.0771 66.863 7.80914C66.9137 6.61849 67.091 6.01049 67.6483 5.1745ZM73.0949 28.1516C73.9309 26.201 76.1096 24.2503 79.3269 22.5783C81.1002 21.6663 83.0762 20.349 84.7735 18.981C86.2428 17.7904 88.1681 16.4477 89.0801 15.9917C90.5494 15.2571 90.9547 15.1811 92.9054 15.1811C94.8054 15.1811 95.236 15.2824 96.5533 15.9411C98.2253 16.8024 99.72 18.4997 100.201 20.121C100.809 22.1477 100.556 23.8956 99.0613 28.3796C97.7693 32.2049 97.6427 32.8129 97.668 34.6622C97.668 35.8022 97.8453 37.7275 98.0733 38.9942C98.8333 43.6048 98.4533 46.3154 96.7053 48.2661C95.1854 50.0141 93.6907 50.622 91.1067 50.6474C87.6614 50.6474 86.0148 49.6087 82.1135 44.9221C81.1255 43.7061 79.0482 41.6541 77.5282 40.3368C73.3483 36.7649 72.2843 34.8142 72.4616 31.2676C72.5376 30.1023 72.7656 28.8863 73.0949 28.1516Z"
          fill="#1F1F1F"

          initial={{
            scale: .6,
            x: 180,
          }}
          animate={controlsHighFive}
          onAnimationComplete={() => !isAnimated && setIsAnimated(true)}
        />
      </g>
      <defs>
        <clipPath id="clip0_244:3260">
          <rect width="180.878" height="108.679" fill="white" transform="matrix(1.19249e-08 -1 -1 -1.19249e-08 159.617 239.609)"/>
        </clipPath>
        <clipPath id="clip1_244:3260">
          <rect width="62" height="159" fill="white" transform="matrix(1.19249e-08 -1 -1 -1.19249e-08 159 62)"/>
        </clipPath>
      </defs>
    </motion.svg>
  );
};